var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AcademicCardsChapter',{attrs:{"page-title":"研究中心活动","section-label":"学科建设","section-route":_vm.sectionRoute,"top-strip-image":_vm.topStripImage,"hero-background-image":_vm.heroBackgroundImage,"sections":_vm.sections}})
}
var staticRenderFns = []

export { render, staticRenderFns }